
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.225 11.67l-8.8-6A.401.401 0 008.8 6v12a.4.4 0 00.625.33l8.8-6a.4.4 0 000-.66zM9.6 17.243V6.757L17.29 12 9.6 17.243z","fill":"#00003C"}}),_c('path',{attrs:{"d":"M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm0 23.2C5.824 23.2.8 18.176.8 12 .8 5.824 5.824.8 12 .8 18.176.8 23.2 5.824 23.2 12c0 6.176-5.024 11.2-11.2 11.2z","fill":"#00003C"}})])
          )
        }
      }
    